<template>
  <div class="tipo-selector">
    <div class="header">
      <button type="button" class="btn-voltar" @click="$emit('voltar')">
        <fa-icon icon="arrow-left" /> Voltar
      </button>
      <h3>Que tipo de mapeamento?</h3>
      <p class="subtitle">Escolha a estratégia que melhor descreve como o valor será calculado.</p>
    </div>

    <div class="tipo-primario">
      <button
        type="button"
        class="tipo-card tipo-card--destaque"
        :aria-label="`Selecionar ${tipoSimples.nome}: ${tipoSimples.descricao}`"
        @click="$emit('selecionar', tipoSimples.tipo)"
      >
        <div class="tipo-icone tipo-icone--lg">
          <fa-icon :icon="tipoSimples.icone" />
        </div>
        <div class="tipo-info">
          <div class="tipo-badge-recomendado">
            <fa-icon icon="star" /> Mais comum
          </div>
          <div class="tipo-nome tipo-nome--lg">{{ tipoSimples.nome }}</div>
          <div class="tipo-desc">{{ tipoSimples.descricao }}</div>
          <div class="tipo-exemplo"><code>{{ tipoSimples.exemplo }}</code></div>
        </div>
        <fa-icon icon="chevron-right" class="tipo-chevron" />
      </button>
    </div>

    <div class="tipo-secao-label">
      <span class="linha-divisora"></span>
      <span class="label-texto">Estratégias específicas</span>
      <span class="linha-divisora"></span>
    </div>

    <div class="tipo-grid">
      <button
        v-for="t in tiposSecundarios"
        :key="t.tipo"
        type="button"
        class="tipo-card"
        :aria-label="`Selecionar ${t.nome}: ${t.descricao}`"
        @click="$emit('selecionar', t.tipo)"
      >
        <div class="tipo-icone">
          <fa-icon :icon="t.icone" />
        </div>
        <div class="tipo-info">
          <div class="tipo-nome">{{ t.nome }}</div>
          <div class="tipo-desc">{{ t.descricao }}</div>
          <div class="tipo-exemplo"><code>{{ t.exemplo }}</code></div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TipoRegraSelector",
  data() {
    return {
      tipos: [
        {
          tipo: "simples",
          nome: "Campo simples",
          icone: "exchange-alt",
          descricao: "Pega o valor de um campo da Verso e envia direto para o ERP.",
          exemplo: "pedido.id  →  U_VS_PedidoEcommerce",
        },
        {
          tipo: "mapeamento",
          nome: "Mapeamento de valores",
          icone: "table",
          descricao: "Traduz cada valor de origem para um valor diferente (decision table).",
          exemplo: "1 → \"PF\"   ·   2 → \"PJ\"",
        },
        {
          tipo: "concatenacao",
          nome: "Concatenação",
          icone: "link",
          descricao: "Une vários campos e textos literais em um único valor.",
          exemplo: "logradouro + \", \" + numero",
        },
        {
          tipo: "coalesce",
          nome: "Primeiro disponível",
          icone: "list-ol",
          descricao: "Usa o primeiro campo da lista que tiver valor preenchido.",
          exemplo: "U_NORD_Order  ou  U_NORD_Ecommerce",
        },
        {
          tipo: "condicional",
          nome: "Condicional avançado",
          icone: "code-branch",
          descricao: "Define várias regras com condições e lógica E/OU para casos complexos.",
          exemplo: "se cobranca = 15 e valor > 5000 → \"APROVAR_MANUAL\"",
        },
      ],
    };
  },
  computed: {
    tipoSimples() {
      return this.tipos.find((t) => t.tipo === 'simples');
    },
    tiposSecundarios() {
      return this.tipos.filter((t) => t.tipo !== 'simples');
    },
  },
};
</script>

<style scoped>
.tipo-selector {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.btn-voltar {
  background: none;
  border: none;
  color: var(--primary);
  font-size: 12px;
  cursor: pointer;
  padding: 4px 0;
  align-self: flex-start;
}
.btn-voltar:hover { text-decoration: underline; }
.header h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-darkest);
  margin: 0;
}
.subtitle {
  font-size: 13px;
  color: var(--text-muted);
  margin: 0;
}
.tipo-primario { margin-bottom: 8px; }
.tipo-card--destaque {
  width: 100%;
  border: 2px solid var(--primary);
  background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
  padding: 20px;
  gap: 16px;
  align-items: center;
}
.tipo-card--destaque:hover {
  box-shadow: 0 4px 16px rgba(58, 62, 129, 0.15);
}
.tipo-icone--lg {
  width: 52px;
  height: 52px;
  font-size: 22px;
}
.tipo-nome--lg { font-size: 16px; }
.tipo-badge-recomendado {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 600;
  color: #b45309;
  background: #fef3c7;
  padding: 2px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.tipo-chevron {
  color: var(--primary);
  font-size: 16px;
  flex-shrink: 0;
}
.tipo-secao-label {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0;
}
.linha-divisora { flex: 1; height: 1px; background: var(--border-default); }
.label-texto {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.tipo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 10px;
}
.tipo-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border: 1px solid var(--border-medium);
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s;
}
.tipo-card:hover {
  border-color: var(--primary);
  background: #fafbff;
  box-shadow: 0 2px 8px rgba(58, 62, 129, 0.08);
}
.tipo-icone {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #eceaf3;
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.tipo-info {
  flex: 1;
  min-width: 0;
}
.tipo-nome {
  font-weight: 600;
  font-size: 14px;
  color: var(--text-darkest);
  margin-bottom: 2px;
}
.tipo-desc {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 6px;
  line-height: 1.4;
}
.tipo-exemplo {
  font-size: 11px;
}
.tipo-exemplo code {
  background: var(--border-soft);
  color: #475467;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Menlo', 'Consolas', monospace;
  font-size: 11px;
}
</style>
